import React, { useState, useRef, useEffect } from 'react';
import Menu from '@mui/icons-material/Menu';
import Tooltip from '../common/Tooltip.jsx';

const SortIcon = ({ sortState }) => {
  const getIconClass = (sortState) => {
    const iconClasses = {
      asc: "fa fa-sort-asc",
      desc: "fa fa-sort-desc",
      default: "fa fa-sort"
    };
    return iconClasses[sortState] || iconClasses.default;
  };

  const iconClass = getIconClass(sortState);

  return (
    <i className={iconClass + ' ml-1'}></i>
  );
};

const HeaderComponent = (props) => {
    const [sortState, setSortState] = useState('inactive');
    const [isFilterActive, setIsFilterActive] = useState(props.column.filterActive);
    const [isMenuHovered, setIsMenuHovered] = useState(false);
    const [isHeaderHovered, setIsHeaderHovered] = useState(false);
    const refButton = useRef(null);
    const onMenuClicked = () => {
        props.showColumnMenu(refButton.current);
    }
  
    const onSortChanged = () => {
      if (props.column.isSortAscending()) {
        setSortState('asc');
      } else if (props.column.isSortDescending()) {
        setSortState('desc');
      } else {
        setSortState('inactive');
      }
    };

    const onFilterActiveChange = () => {
        setIsFilterActive(props.column.filterActive);
      };

  
    const toggleSort = () => {
      if (sortState === 'asc') {
        onSortRequested('desc');
      } else if (sortState === 'desc') {
        onSortRequested('');
      } else {
        onSortRequested('asc');
      }
    };
  
    const onSortRequested = (order) => {
      props.setSort(order);
    };
  
    const onHeaderEnter = () => {
        setIsHeaderHovered(true);
    };
  
    const onHeaderLeave = () => {
        setIsHeaderHovered(false);
    };
  
    useEffect(() => {
        props.column.addEventListener('sortChanged', onSortChanged);
        props.column.addEventListener('filterChanged', onFilterActiveChange);
        onSortChanged();
        onFilterActiveChange();
    
        return () => {
          props.column.removeEventListener('sortChanged', onSortChanged);
          props.column.removeEventListener('filterChanged', onFilterActiveChange);
        };
      }, []);
  
      const sortIcon = props.enableSorting ? (
        <SortIcon sortState={sortState} toggleSort={toggleSort} />
      ) : null;

    const title = (
        <>
            <span>{props.column.colDef.headerName}</span>
            {props.unitName && (
                <span style={{ color: '#666' }}>{` (${props.unitName})`}</span>
            )}
        </>
    )

    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '100%'
        }}
        onMouseEnter={onHeaderEnter}
        onMouseLeave={onHeaderLeave}
      >
        <div onClick={toggleSort}>
        {props.description ? (
              <Tooltip title={props.description} placement='top' arrow>{title}</Tooltip>
          ) : (
              title
          )}

          {isFilterActive && (
              <i className="ml-1 fa fa-filter text-primary"></i>
          )}
          {sortIcon}
        </div>
        {props.enableMenu && (
          <div style={{ marginRight: '3px', cursor: 'pointer', visibility: isHeaderHovered ? 'visible' : 'hidden' }}>
            <Menu
              ref={refButton}
              onClick = {onMenuClicked}
              onMouseEnter={() => setIsMenuHovered(true)}
              onMouseLeave={() => setIsMenuHovered(false)}
              style={{
                color: isMenuHovered ? 'cornflowerblue' : 'inherit',
              }}
            />
          </div>
        )}

      </div>
    );
  };
  
  

export default HeaderComponent;